import deMessages from './data/de'
import enMessages from './data/en'
import esMessages from './data/es'
import plMessages from './data/pl'

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill')
  require('@formatjs/intl-pluralrules/dist/locale-data/de')
  require('@formatjs/intl-pluralrules/dist/locale-data/en')
  require('@formatjs/intl-pluralrules/dist/locale-data/es')
  require('@formatjs/intl-pluralrules/dist/locale-data/pl')
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/de')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/en')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/es')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/pl')
}

export const getLocaleByLang = (lang) => {
  switch (lang) {
    case 'de-DE':
      return 'de'
    case 'de-AT':
      return 'de-at'
    case 'es-ES':
      return 'es'
    case 'pl-PL':
      return 'pl'
    case 'en-GB':
      return 'en-gb'
    case 'en-CA':
      return 'en-ca'
    case 'en-AU':
      return 'en-au'
    case 'en-US':
    default:
      return 'en'
  }
}

export const getMessages = (lang) => {
  switch (lang) {
    case 'de-DE':
    case 'de-AT':
      return deMessages
    case 'es-ES':
      return esMessages
    case 'pl-PL':
      return plMessages
    case 'en-GB':
    case 'en-CA':
    case 'en-AU':
    case 'en-US':
    default:
      return enMessages
  }
}
